import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/gestion/bloqueos")({
  beforeLoad: () => {
    throw redirect({
      to: "/gestion/calendario",
      search: (prev: Record<string, unknown>) => ({ ...prev, tab: "bloqueos" }) as never,
    });
  },
});